module.exports = __webpack_public_path__ + "static/img/bg_3.31297192.png";